module.exports = __webpack_public_path__ + "static/media/Balanza-Comercial-Agropecuario-TLC-TLCUEM_Septiembre_2020.800a7aa9.pdf";